
const GROQ_API_KEY = import.meta.env.VITE_GROQ_API_KEY || '';
const GROQ_URL = 'https://api.groq.com/openai/v1/chat/completions';

export async function aiRiskAssessment(clientDescription: string, checklist: any[], onStream: (chunk: string) => void) {
  if (!GROQ_API_KEY) { onStream('\n\n⚠️ No GROQ_API_KEY found.'); return; }
  const system = `You are a compliance officer with 15 years AML/KYC experience. Analyze this client/scenario against FATF standards. Generate a tailored risk assessment narrative. Suggest specific enhanced measures. Reference applicable regulations. Use professional compliance language.`;
  const res = await fetch(GROQ_URL, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${GROQ_API_KEY}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      model: 'llama-3.3-70b-versatile',
      messages: [
        { role: 'system', content: system },
        { role: 'user', content: `Client description: ${clientDescription}\n\nChecklist items: ${checklist.slice(0, 10).map(c => c.requirement).join('\n')}\n\nGenerate a risk assessment narrative.` }
      ],
      temperature: 0.3,
      stream: true
    })
  });
  const reader = res.body?.getReader(); if (!reader) return;
  const decoder = new TextDecoder();
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    const chunk = decoder.decode(value);
    const lines = chunk.split('\n').filter(l => l.trim().startsWith('data: '));
    for (const line of lines) {
      const json = line.replace('data: ', '');
      if (json === '[DONE]') continue;
      try { const c = JSON.parse(json).choices?.[0]?.delta?.content; if (c) onStream(c); } catch {}
    }
  }
}
